import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SwatchColor = styled.div`
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 5px;
  border-radius: 1px;
  background-color: ${({ color }) => color}
`

const Group = styled(
  ({ colors, className }) => (
    <div className={`swatch-group ${className}`}>
      {colors.map((color, i) => (
        <SwatchColor key={i} color={color} />
      ))}
    </div>
  )
)``

SwatchColor.Group = Group

SwatchColor.propTypes = {
  color: PropTypes.string.isRequired,
}
SwatchColor.defaultProps = {}

export default SwatchColor



// WEBPACK FOOTER //
// ./src/cms/components/productCard/SwatchColor.js